import { registerDecorator } from 'class-validator';
export function IsBefore(property, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: 'isBefore',
            target: object.constructor,
            propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(propertyValue, args) {
                    return propertyValue < args.object[args.constraints[0]];
                },
                defaultMessage(args) {
                    return `"${args.property}" must be before "${args.constraints[0]}"`;
                },
            },
        });
    };
}
//# sourceMappingURL=IsBefore.js.map